import clsx from 'clsx';
import styles from './TemplateUpdatedLabel.module.css';

export function TemplateUpdatedLabel({ children, className }) {
  return <span className={clsx(styles.label, className)}>{children}</span>;
}
